export class ListGoogleWorkspaceGroupsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "search",
            "baseName": "search",
            "type": "string",
            "format": ""
        },
        {
            "name": "ids",
            "baseName": "ids",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGoogleWorkspaceGroupsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
